import { LoyaltyAllowedMatrixDtoToEntity } from "src/app/features/LoyaltyAllowedMatrix/services/mappers/LoyaltyAllowedMatrixDtoToEntity";
import type { LoyaltyAllowedMatrixDtoList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixDtoList";
import type { LoyaltyAllowedMatrixEntityList } from "src/app/features/LoyaltyAllowedMatrix/types/LoyaltyAllowedMatrixEntityList";

export const LoyaltyAllowedMatrixDtoListToEntityList = ({
    ...rest
}: Readonly<LoyaltyAllowedMatrixDtoList>): LoyaltyAllowedMatrixEntityList => {
    return { loyaltyAllowedMatrixs: rest.loyaltyAllowedMatrixs?.map(LoyaltyAllowedMatrixDtoToEntity) };
};
